export const reachGoal = ({ goal, params }: ReachGoalInput) => {
  const { hostname, pathname } = window.location;
  const isDemo = pathname === '/demo' || pathname.startsWith('/demo/');
  const hasCounter = [ 'dita.systems', 'my.vedmarket.ru' ].includes(hostname);

  if (isDemo || !hasCounter) return;

  const counterId = hostname === 'dita.systems' ? 100002317 : 102496326;
  const ym = Reflect.get(window, 'ym');

  if (typeof ym !== 'function') return;

  try {
    if (params) {
      ym(counterId, 'reachGoal', goal, params);
    } else {
      ym(counterId, 'reachGoal', goal);
    }
  } catch {
    // Analytics must not interrupt the button's action.
  }
};


let yandexId: string | undefined;
let yandexIdRequest: Promise<string | undefined> | undefined;
let attribution: UserAttribution = {};

const captureAttribution = (): UserAttribution => {
  const keys: (keyof UserAttribution)[] = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'device', 'region',
  ];
  const params = new URLSearchParams(window.location.search);
  const captured: UserAttribution = {};

  keys.forEach((key) => {
    const value = params.get(key);

    if (value) captured[key] = value;
  });


  return captured;
};

export const initializeMetrica = (): Promise<string | undefined> => {
  if (yandexIdRequest) return yandexIdRequest;

  attribution = captureAttribution();

  const hostname = window.location.hostname;
  const hasCounter = [ 'dita.systems', 'my.vedmarket.ru' ].includes(hostname);
  const ym = Reflect.get(window, 'ym');

  if (!hasCounter || typeof ym !== 'function') {
    yandexIdRequest = Promise.resolve(undefined);
    return yandexIdRequest;
  }

  const counterId = hostname === 'dita.systems' ? 100002317 : 102496326;

  yandexIdRequest = new Promise((resolve) => {
    try {
      ym(counterId, 'getClientID', (value: string) => {
        yandexId = value;
        resolve(value);
      });
    } catch {
      resolve(undefined);
    }
  });

  return yandexIdRequest;
};

export const getMetricaClientId = () => yandexId;

export const getMetricaAttribution = () => attribution;

export const setMetricaUserId = (userId: MeParamsOutput['id']) => {
  const { hostname } = window.location;
  const hasCounter = hostname === 'my.vedmarket.ru';
  const ym = Reflect.get(window, 'ym');

  if (!hasCounter || userId == null || typeof ym !== 'function') return;

  try {
    ym(102496326, 'setUserID', String(userId));
  } catch {
    // Analytics must not interrupt authentication.
  }
};

export const waitForMetricaClientId = (): Promise<string | undefined> => {
  return new Promise((resolve) => {
    const timeout = window.setTimeout(() => resolve(undefined), 5000);

    initializeMetrica().then((value) => {
      window.clearTimeout(timeout);
      resolve(value);
    });
  });
};
